import { DepartmentExtensionInput, ExtensionInput, ExtensionPhoneInput } from 'generated/graphql-types';
import { DepartmentExtensionItemView } from '../models/department-extension.model';

export function createExtensionsInput(
   dndStatus: string,
   office: string,
   extensionPhoneId: number,
   extensionId: number,
   departments: DepartmentExtensionInput[] = []
): ExtensionInput {
   const extensionFields = ['extensionId'];
   const extensionPhoneFields = ['extensionPhoneId', 'dndStatus', 'office'];
   const departmentExtensionFields = ['departmentId', 'extensionId', 'departmentExtensionId'];

   formatExtensionEmbeddedPhoneFields(extensionFields, 'extensionPhone', extensionPhoneFields);
   formatEmbeddedDepartmentExtensionFields(extensionFields, 'departmentExtensions', departmentExtensionFields);

   const departmentExtensions: DepartmentExtensionInput[] = (departments as unknown as DepartmentExtensionItemView[])
      .filter((dep) => !dep.isDeleted)
      .map((dep) => ({
         departmentId: dep.departmentId,
         extensionId: extensionId,
         departmentExtensionId: dep.departmentExtensionId,
         fields: departmentExtensionFields,
      }));
   const extensionPhone: ExtensionPhoneInput = {
      office: office,
      dndStatus: dndStatus,
      extensionPhoneId: extensionPhoneId,
      fields: extensionPhoneFields,
   };
   const extension: ExtensionInput = {
      extensionPhone: extensionPhone,
      departmentExtensions: departmentExtensions,
      extensionId: extensionId,
      fields: extensionFields,
   };

   return extension;
}

function formatExtensionEmbeddedPhoneFields(fields: string[], key: string, embedExtensionPhoneFields: string[]) {
   if (key) {
      for (const embedField of embedExtensionPhoneFields) {
         fields.push(`${key}.${embedField}`);
      }
   }
}

function formatEmbeddedDepartmentExtensionFields(
   fields: string[],
   key: string,
   embedDepartmentExtensionFields: string[]
) {
   if (key) {
      for (const embedField of embedDepartmentExtensionFields) {
         fields.push(`${key}.${embedField}`);
      }
   }
}
